var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgArrowRight(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14.293,
    height: 22,
    viewBox: "0 0 14.293 22",
    fill: "#002395",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.3,2C3,2,2.6,2.1,2.4,2.4c-0.5,0.5-0.5,1.3,0,1.8L9.2,11l-6.8,6.8c-0.5,0.5-0.5,1.3,0,1.8 c0.5,0.5,1.3,0.5,1.8,0l7.7-7.7c0.5-0.5,0.5-1.3,0-1.8L4.2,2.4C4,2.1,3.6,2,3.3,2 M3.3,0C4.2,0,5,0.3,5.6,1l7.8,7.8 c1.2,1.3,1.1,3.3-0.1,4.5L5.6,21c-0.6,0.6-1.4,1-2.3,1c-0.9,0-1.7-0.3-2.3-1c-0.6-0.6-1-1.4-1-2.3c0-0.9,0.3-1.7,1-2.3L6.4,11L1,5.6 C0.3,5,0,4.2,0,3.3C0,2.4,0.3,1.6,1,1C1.6,0.3,2.4,0,3.3,0z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRight);
export default __webpack_public_path__ + "static/media/arrow-right.71c337900a8e8ce0789a7c743a8f79d1.svg";
export { ForwardRef as ReactComponent };